import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton, CHECKOUT_URL, PRICE_USD } from './Shared';
const heroImage = {
  src: 'https://cdn.magicpatterns.com/uploads/kRZUd8bNEGVCswjSgsEGvj/Mockup_con_buena_calidad_sin_fondo.png',
  alt: 'Mega Pack Chi Kung: los 3 tomos, las plantillas clínicas y los 6 bonus de regalo'
};
const badges = [{
  emoji: '📘',
  label: '100% PDF'
}, {
  emoji: '⚡',
  label: 'Acceso en 5 minutos'
}, {
  emoji: '🧘',
  label: 'Todos los niveles'
}];
const reassurances = [{
  emoji: '💳',
  label: 'Pago único'
}, {
  emoji: '⚡',
  label: 'Acceso inmediato'
}, {
  emoji: '🛡️',
  label: 'Garantía 7 días'
}];
export const Hero = () => {
  return <header className="relative overflow-hidden" data-id="element-97" data-mp="nc876ng09kij">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-98" data-mp="nbey3ftkqix8">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[760px] h-[760px] max-w-[130vw] rounded-full bg-brand-goldLight/25 blur-[150px]" data-id="element-99" data-mp="3d2tln1u126au" />
        <div className="absolute top-16 right-[3%] font-display text-[96px] md:text-[170px] leading-none text-brand-purpleDark/[0.06] select-none animate-float-soft" style={{
        animationDelay: '0.8s'
      }} data-id="element-100" data-mp="3j9k730lk2xau">
          氣
        </div>
        <div className="absolute bottom-16 left-[3%] font-display text-[80px] md:text-[140px] leading-none text-brand-purpleDark/[0.05] select-none animate-float-soft" style={{
        animationDelay: '2s'
      }} data-id="element-101" data-mp="3e9fqzbok84l5">
          和
        </div>
        <div className="hidden lg:block absolute top-[18%] left-[4%] w-56 h-56 rounded-full border border-brand-gold/25" data-id="element-102" data-mp="35aasg5d00b8z" />
        <div className="hidden lg:block absolute bottom-[12%] right-[4%] w-48 h-48 rounded-full border border-brand-purpleDark/10" data-id="element-103" data-mp="2qhqwpps6h61k" />
      </div>

      {/* Above the fold: headline, mockup and CTA — no scroll needed on mobile */}
      <motion.div initial={{
      opacity: 0,
      y: 14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative z-10 mx-auto flex h-[calc(100svh-40px)] max-h-[calc(100svh-40px)] w-full max-w-6xl flex-col items-center justify-center gap-[0.8vh] px-3 pt-2 pb-2 text-center sm:px-6 md:h-auto md:max-h-none md:gap-6 md:py-14" data-id="element-104" data-mp="2lkiiu1e2bo64">
        <div className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full border border-brand-gold/60 bg-brand-paper/80 px-4 py-1.5 shadow-sm" data-id="element-105" data-mp="ddne9xklijhu">
          <span aria-hidden="true" className="text-sm" data-id="element-106" data-mp="1ayjilhmnxm7u">
            🌿
          </span>
          <span className="font-seal text-[10px] md:text-xs uppercase tracking-seal text-brand-goldDark" data-id="element-107" data-mp="15zq35jntfl51">
            Lumen Akasha™
          </span>
        </div>

        {/* Exactly two lines, at every width */}
        <h1 className="shrink-0 font-display font-bold text-brand-purpleDark" style={{
        fontSize: 'clamp(2.2rem, min(9.6vw, 6.4svh), 4.75rem)',
        lineHeight: 1.05,
        letterSpacing: '-0.02em'
      }} data-id="element-108" data-mp="x3h1dycd8afq">
          <span className="block whitespace-nowrap" data-id="element-109" data-mp="1xavy8m3b8c8b">
            Sesiones más{' '}
            <span className="relative inline-block" data-id="element-110" data-mp="21bxx31tbem9r">
              <span aria-hidden="true" className="absolute inset-x-[-4px] bottom-[0.08em] h-[0.26em] bg-brand-goldLight/60" data-id="element-111" data-mp="269zi3saawvnv" />
              <span className="relative" data-id="element-112" data-mp="2b0zemwfidbpu">efectivas</span>
            </span>
          </span>
          <span className="block whitespace-nowrap" data-id="element-113" data-mp="2g0bzjbmtk8ps">y sin improvisar.</span>
        </h1>

        <p className="mx-auto max-w-[34ch] shrink-0 font-display italic text-brand-textLight/85 leading-snug" style={{
        fontSize: 'clamp(0.95rem, min(4.4vw, 2.2svh), 1.5rem)'
      }} data-id="element-114" data-mp="2kyn9dmd46j80">
          El conocimiento ya lo tienes. El sistema para aplicarlo, ahora
          también.
        </p>

        <div className="flex w-full shrink-0 flex-wrap items-center justify-center gap-1.5 md:gap-3 text-[10px] sm:text-xs md:text-sm" data-id="element-115" data-mp="umzg9pwb9u4p">
          {badges.map(({
          emoji,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5 bg-brand-paper border border-brand-purpleDark/10 px-2.5 py-1 md:px-3 md:py-1.5 rounded-sm whitespace-nowrap text-brand-textLight" data-id="element-116" data-mp="4b46ts95i2ix">
              <span aria-hidden="true" data-id="element-117" data-mp="e88slqz33vz7">{emoji}</span>
              {label}
            </span>)}
        </div>

        {/* Mockup: deliberately capped on mobile so the headline stays the
            largest element. The artwork carries transparent margins, so it is
            cropped rather than letterboxed. */}
        <div className="mx-auto h-[24svh] max-h-[24svh] w-full max-w-[14rem] shrink-0 overflow-hidden sm:max-w-xl md:h-[38vh] md:max-h-none md:max-w-[42rem]" data-id="element-118" data-mp="3cp320roatjvd">
          <img src={heroImage.src} alt={heroImage.alt} className="h-full w-full scale-[1.06] object-cover object-center drop-shadow-2xl md:scale-100 md:object-contain md:object-top" draggable={false} decoding="async" data-id="element-119" data-mp="3moc2829rbuq6" />
        </div>

        <p className="mx-auto max-w-[38ch] shrink-0 font-display text-brand-purpleDark leading-snug" style={{
        fontSize: 'clamp(0.95rem, min(4.4vw, 2.2svh), 1.5rem)'
      }} data-id="element-120" data-mp="19hm57qgv9seq">
          Pasa de la planificación caótica a una práctica clínica profesional
          hoy mismo. 🧘‍♂️
        </p>

        <div className="flex w-full shrink-0 flex-col items-center gap-[0.8vh] md:gap-4" data-id="element-121" data-mp="14k3upvn7b54m">
          <CTAButton variant="purple" href={CHECKOUT_URL} className="w-full max-w-md rounded-full cta-shimmer relative overflow-hidden ring-1 ring-brand-goldLight/50 hover:ring-brand-goldLight" style={{
          fontSize: 'clamp(1rem, min(4.6vw, 2.4svh), 1.5rem)',
          paddingTop: 'clamp(0.7rem, 1.9svh, 1.5rem)',
          paddingBottom: 'clamp(0.7rem, 1.9svh, 1.5rem)'
        }} data-id="element-122" data-mp="1sagcdy890g8e">
            <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-123" data-mp="bvet7vi8gxsc">
              Quiero mi Mega Pack — {PRICE_USD}
              <span aria-hidden="true" data-id="element-124" data-mp="2eg94gqaq4faz">→</span>
            </span>
          </CTAButton>

          <ul className="flex w-full max-w-md items-stretch justify-center divide-x divide-brand-gold/30 rounded-full border border-brand-gold/40 bg-brand-paper/70 text-brand-textLight" data-id="element-125" data-mp="29jin7zn6ndnz">
            {reassurances.map(({
            emoji,
            label
          }) => <li key={label} className="flex flex-1 flex-col items-center gap-0.5 px-2 py-2 text-[11px] leading-tight md:text-[13px]" data-id="element-126" data-mp="1zqto848tjs9j">
                <span aria-hidden="true" className="text-sm md:text-base" data-id="element-127" data-mp="1qqoh7v7jevvw">
                  {emoji}
                </span>
                <span className="font-medium" data-id="element-128" data-mp="1gttk9gqwx3jq">{label}</span>
              </li>)}
          </ul>
        </div>
      </motion.div>
    </header>;
};